import { useSelector } from "react-redux";
import { selectGlobalLoader } from "../../store/slices/uiSlice";
import LoaderLoop from "./loader/LoaderLoop";
import "./GlobalLoader.css";

/**
 * GlobalLoader — the SCREEN loader. Frosted full-viewport veil, the mint
 * loop centered, optional Hebrew message. No card, no shadow.
 *
 * For a loading area INSIDE a page/card/modal use `ContentLoader` instead.
 *
 * Redux:  dispatch(showGlobalLoader("טוען..."));  dispatch(hideGlobalLoader());
 * Props:  {isSaving && <GlobalLoader message="שומר מטופל..." />}
 *
 * @param {string} [message]  With props the overlay is always visible;
 *                            without, Redux state rules.
 */
function GlobalLoader({ message: propMessage }) {
  const globalState = useSelector(selectGlobalLoader);

  const isUsingProps = propMessage !== undefined;
  const isVisible = isUsingProps ? true : globalState.isVisible;
  const message = isUsingProps ? propMessage : globalState.message;

  if (!isVisible) return null;

  return (
    <div className="ck-loader-veil" role="status" aria-live="polite">
      <div className="ck-loader ck-loader--overlay">
        <LoaderLoop size="lg" />
        {message ? <p className="ck-loader-message">{message}</p> : <span className="ck-sr-only">טוען</span>}
      </div>
    </div>
  );
}

export default GlobalLoader;
